<template>

    <div class="maintenance-container" v-if="maintenance">

        <img class="maintenance-img" src="/img/foxy/connect-grey.svg">

        <h1 class="maintenance-title">{{ $t('maintenance_title') }}</h1>

        <p class="maintenance-text">{{ $t('maintenance_text_return') }}</p>

        <p class="maintenance-text">{{ $t('maintenance_text_thanks') }}</p>

    </div>

</template>

<script>

export default {

    name: 'maintenance',

    props: {

        maintenance: {
            type: Boolean,
            default: false
        }

    }

}

</script>

<style scoped lang="scss">

    .maintenance-container {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background-color: $blue;
        color: $white;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 34px;
        background-image: url('/img/background/maintenance/native.svg');
        background-repeat: no-repeat;
        background-position: bottom;
        background-size: contain;
        @media screen and (min-width: $above-tablet-length) {
            padding-top: 201px;
            background-image: url('/img/background/maintenance/desktop.svg');
        }
    }

    .maintenance-img {
        width: 88px;
        object-fit: contain;
        @media screen and (min-width: $above-tablet-length) {
            width: 128px;
        }
    }

    .maintenance-title {
        font-size: 28px;
        font-weight: bold;
        line-height: 1.14;
        letter-spacing: -0.2px;
        text-align: center;
        margin: 15px 0 8px;
        @media screen and (min-width: $above-tablet-length) {
            font-size: 32px;
            line-height: 1.25;
        }
    }

    .maintenance-text {
        font-size: 17px;
        font-weight: 500;
        line-height: 1.41;
        text-align: center;
        margin: 0;
        @media screen and (min-width: $above-tablet-length) {
            font-size: 20px;
            line-height: 1.2;
            letter-spacing: -0.2px;
        }
    }


</style>
